"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TextField_1 = require("@material-ui/core/TextField/TextField");
var Stop_1 = require("@material-ui/icons/Stop");
var FieldCoreBase_1 = require("@react-form-fields/core/components/FieldCoreBase");
var ValidationContextRegister_1 = require("@react-form-fields/core/components/ValidationContextRegister");
var React = require("react");
var config_1 = require("../../config");
var PickerDialog_1 = require("./PickerDialog");
var FieldColor = /** @class */ (function (_super) {
    tslib_1.__extends(FieldColor, _super);
    function FieldColor(props) {
        var _this = _super.call(this, props) || this;
        _this.showPicker = function () { return _this.setState({ showPicker: true }); };
        _this.hidePicker = function () { return _this.setState({ showPicker: false }); };
        _this.onChange = function (event) {
            config_1.getConfig().validationOn === 'onChange' && _this.setState({ showError: true });
            _this.props.onChange(event.hex);
        };
        _this.onBlur = function (e) {
            _this.props.onBlur && _this.props.onBlur(e);
            config_1.getConfig().validationOn === 'onBlur' && _this.setState({ showError: true });
        };
        _this.state = tslib_1.__assign({}, _this.state, { showPicker: false });
        return _this;
    }
    FieldColor.prototype.render = function () {
        var showPicker = this.state.showPicker;
        var _a = this.props, value = _a.value, helperText = _a.helperText, multiline = _a.multiline, validationContext = _a.validationContext, InputProps = _a.InputProps, extraProps = tslib_1.__rest(_a, ["value", "helperText", "multiline", "validationContext", "InputProps"]);
        return (React.createElement(React.Fragment, null,
            React.createElement(ValidationContextRegister_1.default, { field: this }),
            React.createElement(TextField_1.default, tslib_1.__assign({}, tslib_1.__assign({ fullWidth: true, margin: 'normal' }, (extraProps), { required: this.isRequired, value: (value === undefined || value === null ? '' : value).toString(), error: !!this.errorMessage, helperText: this.errorMessage || helperText, onChange: this.onChange, onBlur: this.onBlur, submitted: null, touched: null, loading: null }), { onClick: this.showPicker, InputProps: tslib_1.__assign({ startAdornment: React.createElement(Stop_1.default, { color: 'inherit', style: { color: value } }) }, (InputProps || {})) })),
            showPicker && (React.createElement(PickerDialog_1.default, { value: value || '', onDismiss: this.hidePicker, onChange: this.onChange }))));
    };
    return FieldColor;
}(FieldCoreBase_1.default));
exports.default = FieldColor;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Color/index.js
// module id = 439
// module chunks = 58